/**
 * Palomar Scheduler
 * Copyright 2013, Caleb Evans
 */
(function($, window, document, parseFloat, Date, setTimeout, clearTimeout, localStorage, JSON) {
$(document).ready(function() {

// jQuery elements
var $$ = {
	// Container elements
	body: $('body'),
	header: $('.header'),
	content: $('.content'),
	schedule: $('.Schedule'),
	suggestionList: $('.search.suggestions'),
	// Controls
	controls: $('.controls'),
	loading: $('.loading.message'),
	toggleStarred: $('img.toggle-starred'),
	toggleStarredContainer: $('.toggle-starred.container'),
	starHint: $('.toggle-starred.hint'),
	// Messages
	noResults: $('.no-results.message'),
	noStarred: $('.no-starred.message'),
	searchInfo: $('.search-info.message'),
	starredInfo: $('.starred-info.message'),
	searchHint: $('.search.message'),
	// Search
	searchField: $('input.search'),
	searchGoIcon: $('img.search.go'),
	searchClearIcon: $('img.search.clear'),
	searchPopup: $('.search.popup'),
	// Semester name
	semesterName: $('.semester.name'),
	semesterId: $('.semester.id')
};

// Script parameters
var params = {

	// Set base path
	basePath: '/palomar-scheduler',

	// Delay between each course iteration (if parsing is asynchronous)
	iterationDelay: 10,
	// The total number of courses in the schedule
	courseCount: 0,
	// The current iteration when parsing courses
	iteration: 0,
	// The size of each group of iterations that are to be parsed synchronously
	iterationStep: 10,
	// The number to which the currently displayed iteration count will be rounded
	displayedIterationStep: 10,
	// Indicates whether or not all courses have finished loading
	finishedLoading: false,

	// Searching

	// Delay after each keystroke before searching query
	searchDelay: 1000 / 3,
	// The maximum number of search suggestions to display
	maxSuggestions: 50,
	// The maximum number of search results to display
	maxResults: 100,
	// Internal timer for efficiently queueing searches
	searchTimer: null,
	// Last typed query
	lastQuery: '',
	// Selected suggestion index
	suggestionIndex: -1,

	// Regular expressions
	exp: {
		// Course name/ID
		courseName: /^([a-z ]+)(?=([ \-])([\d\.]+)([a-z]?)$)/gi,
		// Course number
		courseNum: /(\d+([a-z])?)$/gi,
		// Section name/ID
		sectionName: /^([a-z ]+)$/gi,
		// Class ID
		classId: /^\#?(\d+)$/gi,
		// Fast-track classes
		fastTrack: /^\(\d+\/\d+\-\d+\/\d+\)/gi,
		// Word separator
		separator: /[ \-]/gi,
		// URLs
		url: /((https?:\/\/)([\da-z\.\-]+)\.([a-z\.]{2,6})([\/\w \.\-]*)*\/?)/gi,
		// Instructor names
		instructorName: /^(prof(essor)?\.?) ([\w\- ]+)$/gi,
		// Invalid search query characters
		queryFilter: /[^a-z0-9\- ]/gi,
	}

};

// Data maps

var maps = {
	// class ID (12345) -> courses
	classes: {},
	// course ID (math-140) -> courses
	courses: {},
	// course title (oral communication) -> courses
	courseTitles: {},
	// section ID (math) -> course numbers (140) -> course
	courseNums: {},
	// instructor (larson p) -> course ID -> class ID -> class
	instructors: {},
	// section ID (math) -> courses
	sections: {},
	// section name (Math) -> section ID (math)
	sectionIds: {},
	// section ID (math) -> section name (Math)
	sectionNames: {},
	// section ID (anatomy) -> section ID alias (zoology)
	sectionIdAliases: {
		'alcohol': 'aods',
		'anatomy': 'zoology',
		'bacteriology': 'microbiology',
		'first aid': 'emt',
		'kinesiology': 'athletics',
		'life sciences': 'biology',
		'meteorology': 'geology',
		'nutrition': 'family consumer sciences',
		'physical education': 'athletics',
		'physiology': 'zoology',
		'spelling': 'read',
		'wood': 'cft'
	}
};

// A local copy of the HTML element for the current schedule
var $currentSchedule = null;

// The latest search results
var $searchResults = $();

// Current list of suggestion elements
var $currentSuggestions = $();

// Current list of suggestions
var currentSuggestions = [];

// Map of all courses that contain at least one starred class
var starredCourses = {
	count: 0
};

// List of starred classes for this semester
var starredClassIds = [];

// A template star element for creating other star elements
var $newStar = $('<img src="' + params.basePath + '/resources/icons/unstarred.svg" alt="Toggle class star" class="star" />');

// Load starred classes from local storage
function loadStarredClasses() {
	var $course, $class, classId, c,
		data;

	// If browser supports local storage
	if (window.localStorage) {

		// Load starred class IDs from local storage
		data = localStorage.getItem(params.starredEntryName);
		if (data !== null) {

			// Parse JSON string into a list of starred classes
			starredClassIds = JSON.parse(data);

			// Loop through stored list of starred classes
			for (c = 0; c < starredClassIds.length; c += 1) {
				// Retrieve the currently iterated class ID
				classId = starredClassIds[c];

				if (maps.classes[classId] === undefined) {
					// Unstar class if it cannot be found

					// Remove class from list of starred classes
					starredClassIds.splice(c, 1);
					// Adjust iterator variable accordingly
					c -= 1;

				} else {
					// Otherwise, star class as usual

					// Locate necessary elements using class ID
					$course = $(maps.classes[classId]);
					$class = $course.find('#class-' + classId);
					// Star this class
					toggleClassStar($class);

				}

			}

		}

	}

}

// Save starred classes to local storage
function saveStarredClasses() {
	var data;
	// If browser supports local storage
	if (window.localStorage) {
		// Save starred classes to local storage
		data = JSON.stringify(starredClassIds);
		localStorage.setItem(params.starredEntryName, data);
	}
}

// Collapse whitespace in the given string
function trimWhitespace(str) {
	if (str) {
		// Collapse consecutive spaces to a single space
		str = str.replace(/\s+/gi, ' ');
		// Remove whitespace from beginning and end of string
		str = str.replace(/(^\s)|(\s$)/gi, '');
	}
	return str;
}

// Capitalize the given string
function capitalize(str) {
	return str.substr(0, 1).toUpperCase() + str.substring(1);
}

// Convert a semester ID to name
function semesterIdToName(semesterId) {
	var semesterName = semesterId;
	semesterName = semesterName.replace(/-/gi, ' ');
	return capitalize(semesterName);
}

// Determine ID for the given section name
function sectionNameToId(sectionName) {
	if (maps.sectionIds[sectionName] !== undefined) {
		return maps.sectionIds[sectionName];
	} else {
		return sectionName;
	}
}

// Determine ID from given course/semester courseName
function courseNameToCourseId(courseName) {
	var courseId = courseName.toLowerCase();
	// Collapse whitespace
	courseId = courseId.replace(/\s+/gi, ' ');
	courseId = courseId.replace(/^n /gi, 'n');
	// Convert a section courseName to section ID if possible
	courseId = courseId.replace(
		params.exp.courseName,
		function(all, sectionName) {
			return sectionNameToId(sectionName);
		}
	);
	// Convert spaces to the defined separator
	courseId = courseId.replace(/\s/gi, '-');
	return courseId;
}

// Determine section ID from given course ID
function courseIdToSectionId(courseId) {
	var sectionIds = courseId.match(params.exp.courseName);
	if (sectionIds === null) {
		return null;
	} else {
		return sectionNameToId(sectionIds[0]);
	}
}

// Determine course number from course ID
function courseIdToCourseNum(courseId) {
	var courseNums = courseId.match(params.exp.courseNum);
	if (courseNums === null) {
		return null;
	} else {
		return courseNums[0];
	}
}

// Functions for manipulating instructor names

// Put last name before first initial in the given instructor name
function lastBeforeFirst(instructorName) {
	return instructorName.replace(/^(\w) ([\w\- ]+)$/gi, '$2 $1');
}
// Put first initial before last name in the given instructor name
function firstBeforeLast(instructorName) {
	return instructorName.replace(/^([\w\- ]+) (\w)$/gi, '$2 $1');
}
// Remove professor title from the given instructor name
function removeInstructorTitle(instructorName) {
	return instructorName.replace(params.exp.instructorName, '$3');
}

// Remove empty campus headings from the given course
function removeEmptyCampusHeadings($course) {
	var $campusHeadings, $campusHeading, h;

	// Remove campus headings with no associated classes
	$campusHeadings = $course.find('.CampusHeading');
	for (h = 0; h < $campusHeadings.length; h += 1) {
		$campusHeading = $campusHeadings.eq(h);
		if ($campusHeading.next('.Class').length === 0) {
			$campusHeading.remove();
		}
	}

}

// Remove classes in course that do not match the given selector
function removeClassesNotMatching($course, selector) {
	var $classes, $unmatchedClasses;

	// Retrieve all classes in course
	$classes = $course.find('.Class');

	// Remove classes not taught by instructor
	$unmatchedClasses = $classes.not(selector);
	$unmatchedClasses.remove();

	// Also remove campus headings with no classes
	removeEmptyCampusHeadings($course);

}

// Sort course names alphanumerically
function sortAlphanumerically(name1, name2) {
	var num1, num2;

	// Loop for a course number in each argument
	num1 = name1.match(params.exp.courseNum);
	num2 = name2.match(params.exp.courseNum);

	// If each argument contains a course number
	if (num1 !== null && num2 !== null) {
		// Compare those course numbers as numerical values

		num1 = parseFloat(num1);
		num2 = parseFloat(num2);
		return (num1 - num2);

	} else {
		// Otherwise, compare the section names as strings

		if (name1 > name2) {
			return 1;
		} else if (name1 < name2) {
			return -1;
		}

	}
	return 0;

}

// Sort search results (each results is a course element)
function sortCourses(course1, course2) {
	return sortAlphanumerically(course1.id, course2.id);
}

// Sort search suggestions (each suggestion is a partial course name)
function sortCourseNames(courseName1, courseName2) {
	return sortAlphanumerically(courseName1, courseName2);
}

// Update course count on page
function updateCourseCount() {
	$$.loading.html(params.iteration + ' of ' + params.courseCount + ' courses loaded.');
}

// Show the given element
function show($element) {
	$element.addClass('visible');
}
// Hide the given element
function hide($element) {
	$element.removeClass('visible');
}

// Star the given class or star
function starElem($elems) {
	var e;
	$elems.addClass('starred');
	for (e = 0; e < $elems.length; e += 1) {
		if ($elems[e].src !== undefined) {
			$elems[e].src = params.basePath + '/resources/icons/starred.svg';
		}
	}
}
// Unstar the given class or star
function unstarElem($elems) {
	var e;
	$elems.removeClass('starred');
	for (e = 0; e < $elems.length; e += 1) {
		if ($elems[e].src !== undefined) {
			$elems[e].src = params.basePath + '/resources/icons/unstarred.svg';
		}
	}
}

// Update starred class information
function updateStarredClassInfo() {
	// Build message string
	var message = '',
		$course, $units, courseId,
		totalUnits = 0;

	// Display number of starred classes
	message += starredCourses.count + ' course';

	// Handle plural nouns
	if (starredCourses.count !== 1) {
		message += 's';
	}

	// Add comma to separate various information
	message += ', ';

	// Display number of starred classes
	message += starredClassIds.length + ' starred class';

	// Handle plural nouns
	if (starredClassIds.length !== 1) {
		message += 'es';
	}

	// Sum the units for all starred courses
	for (courseId in starredCourses) {
		if (starredCourses.hasOwnProperty(courseId)) {

			// Ignore special properties
			if (courseId !== 'count') {

				$course = $(starredCourses[courseId]);
				$units = $course.find('.Units');
				// Add units to sum
				totalUnits += parseFloat($units.html());

			}

		}
	}

	// Add comma to separate various information
	message += ', ' + totalUnits + ' unit';

	// Handle plural nouns
	if (totalUnits !== 1) {
		message += 's';
	}

	// Update info message
	$$.starredInfo.html(message);
}

// Toggle star for the given class
function toggleClassStar($someClass) {
	var $someCourse, $course, courseId,
		$class, classId, c,
		$someStar, $star;

	// Retrieve the parent course for this class
	$someCourse = $someClass.parent('.Course');
	// Retrieve course and class IDs
	courseId = $someCourse[0].id.match(/(\w+)\-(\w+)$/gi)[0];
	classId = $someClass[0].id.match(/(\d+)/gi)[0];

	if (maps.classes[classId] && maps.classes[classId].length !== 0) {

		// Retrieve necessary elements
		$course = $(maps.classes[classId]);
		$class = $course.find('#class-' + classId);
		$star = $class.find('.star');
		$someStar = $someClass.find('.star');

		if ($star.hasClass('starred') === false) {
			// Star elements if they are unstarred
			if ($someClass !== $class) {
				starElem($someStar);
				starElem($someClass);
				starElem($star);
				starElem($class);
			}
			// If class ID is not in list of starred class IDs
			if ($.inArray(classId, starredClassIds) === -1) {
				// Add class ID to list of starred class IDs
				starredClassIds.push(classId);
			}
			// If course is not already a starred course
			if (starredCourses[courseId] === undefined) {
				// Add course to map of starred courses
				starredCourses[courseId] = $course[0];
				starredCourses.count += 1;
				starElem($someCourse);
				starElem($course);
			}
		} else {
			// Unstar elements if they are starred
			if ($someClass !== $class) {
				unstarElem($someStar);
				unstarElem($someClass);
				unstarElem($star);
				unstarElem($class);
			}
			// Loop through list of starred class IDs
			for (c = 0; c < starredClassIds.length; c += 1) {
				// If iterated class ID matches the given class ID
				if (starredClassIds[c] === classId) {
					// Remove class ID from list
					starredClassIds.splice(c, 1);
					// Exit loop
					break;
				}
			}
			// If course has no starred classes remaining
			if ($course.find('.starred').length === 0) {
				// Remove course from the map of starred courses
				delete starredCourses[courseId];
				starredCourses.count -= 1;
				if ($someCourse !== $course) {
					unstarElem($someCourse);
					unstarElem($course);
				}
			}
		}

	}
	updateStarredClassInfo();
	saveStarredClasses();

}

// Hide all starred classes
function hideStarredClasses() {

	// Unstar the star control if it is starred
	unstarElem($$.toggleStarred);
	$$.starHint.html('show starred classes');

	// Hide messages
	hide($$.noStarred);
	hide($$.starredInfo);
	if ($searchResults.length === 0) {
		// Inform user if there are no starred classes
		show($$.noResults);
	} else {
		// Otherwise, show information for starred classes
		show($$.searchInfo);
	}
	// Remove all starred classes from displayed schedule
	$$.schedule.empty();
	// If there is at least one search result
	if ($searchResults.length !== 0) {
		// Display search results in schedule
		$$.schedule.append($searchResults.clone());
	}

}

// Show all starred classes
function showStarredClasses() {
	var courseId,
		$starred, starredList,
		$starredCourse, starredCourse;

	// Remove search results from schedule
	$$.schedule.empty();

	// Hide messages
	hide($$.noResults);
	hide($$.searchInfo);
	hide($$.loading);

	// Star the star control if it is unstarred
	starElem($$.toggleStarred);
	$$.starHint.html('hide starred classes');

	if (starredCourses.count === 0) {
		// Inform user if they have not starred any classes

		show($$.noStarred);

	} else {

		// Retrieve and organize starred courses
		starredList = [];
		for (courseId in starredCourses) {
			// Ignore properties from prototype chain
			if (starredCourses.hasOwnProperty(courseId)) {
				// Ignore special properties
				if (courseId !== 'count') {

					starredCourse = starredCourses[courseId];
					$starredCourse = $(starredCourse).clone();

					// Remove unstarred classes from course
					removeClassesNotMatching($starredCourse, '.starred');

					// Remove empty campus headings
					removeEmptyCampusHeadings($starredCourse);

					// Add course to list of starred courses
					starredList.push($starredCourse[0]);

				}
			}
		}

		// Sort the list of courses by ID
		starredList.sort(sortCourses);

		// Create a jQuery object from the list of starred courses
		$starred = $(starredList);

		// Show information on starred classes
		show($$.starredInfo);

		// Display starred courses in schedule
		$$.schedule.append($starred);

	}

}

// Toggle the display of starred classes
function toggleStarredClasses() {

	// Toggle the state of the star control
	if ($$.toggleStarred.hasClass('starred')) {
		hideStarredClasses();
	} else {
		showStarredClasses();
	}

}

// Link the given instructor name to RateMyProfessors.com
function linkToRMP(all, lastName, firstInitial) {
	return '<a href="https://www.ratemyprofessors.com/search/professors?q=' + lastName + '&sid=U2Nob29sLTEzMzQ=" target="_blank" rel="noopener">' + lastName + '</a> ' + firstInitial;
}

// Code to run when schedule parsing completes
function finish() {

	params.finishedLoading = true;
	// Calculate the time elapsed since the loading began
	params.endTime = new Date();
	params.time = params.endTime - params.startTime;
	// Display loading time as tooltip
	$$.loading.prop({
		title: 'Loading time: ' + params.time + 'ms'
	});
	// Update the displayed number of courses loaded
	updateCourseCount();
	// Show search hint unless user has already searched
	if ($$.schedule.html() === '') {
		show($$.searchHint);
	}
	// Enable search field
	$$.searchField.prop({
		disabled: false,
		placeholder: 'Search'
	});
	$$.searchGoIcon.removeClass('loading');
	$$.toggleStarredContainer.removeClass('loading');
	// Load starred classes into schedule
	loadStarredClasses();
}

// Parse the next course
function parseNextCourse() {
	parseCourse($$.courseLines.eq(params.iteration));
}

// Parse an individual course
function parseCourse($courseLine) {

	// Define variables
	var $courseElems, $allCourseElems,
		$courses, $course, $firstCourse,
		$courseTitle, courseTitle, $units, units,
		courseName, courseNum, courseId, sectionId,
		$classes, $class, $firstClass, $firstClassTable,
		$otherClass, $otherClasses, $otherClassLines,
		$classTable, $classLines, $classLine, o, l,
		$classNotes, classId, id, classLineClasses,
		$instructor, instructorName;

	// Do not show courses under which no classes have been listed
	if ($courseLine.next('.CourseLine').length === 0) {

		// Determine course name for this course
		courseName = $courseLine.find('.CourseDisc').html();
		// Determine course and section IDs
		courseId = courseNameToCourseId(courseName);
		sectionId = courseIdToSectionId(courseId);
		courseNum = courseIdToCourseNum(courseId);
		// Retrieve course units
		$units = $courseLine.find('.Units');
		units = $units.html();
		// Remove decimals and parens from units
		if (units) {
			units = units
			.replace(/\.0/gi, '')
			.replace(/[\)\(]/gi, '');
			// Update course units
			$units.html(units);
		}

		// Retrieve course title
		$courseTitle = $courseLine.find('.CourseTitle');
		courseTitle = $courseTitle.html();
		// Put a space before and after any slash in this course's title
		courseTitle = courseTitle.replace(/\//gi, ' / ');
		// Update course title
		$courseTitle.html(courseTitle);

		// Retrieve all course elements not including the course header
		$courseElems = $courseLine.nextUntil('.CourseLine');

		// Retrieve all elements related to this course
		$allCourseElems = $courseLine.add($courseElems);

		// Create a container for all course elements
		$course = $('<div class="Course"></div>');
		$course[0].id = 'course-' + courseId;

		// Put container in place of course header
		$course.insertBefore($courseLine);

		// Move all course elements to course container
		$allCourseElems.appendTo($course);

		// Update course maps
		if (maps.courses[courseId] === undefined) {
			maps.courses[courseId] = [];
		}
		maps.courses[courseId].push($course[0]);

		// Update section maps
		if (maps.sections[sectionId] === undefined) {
			maps.sections[sectionId] = [];
		}
		maps.sections[sectionId].push($course[0]);

		// Update course title maps
		courseTitle = sanitizeQuery(courseTitle);
		if (maps.courseTitles[courseTitle] === undefined) {
			maps.courseTitles[courseTitle] = [];
		}
		maps.courseTitles[courseTitle].push($course[0]);


		// Update course number maps
		if (maps.courseNums[sectionId] === undefined) {
			maps.courseNums[sectionId] = {};
		}
		maps.courseNums[sectionId][courseNum] = $course[0];

		// Reset stored class container and info
		$class = null;
		$classTable = null;
		classId = null;

		$classLines = $course.find('.ClassLine');

		for (l = 0; l < $classLines.length; l += 1) {

			$classLine = $($classLines[l]);
			id = $classLine.find('.ClassNumber').html();
			id = trimWhitespace(id);

			// If ID exists (signifying the first class row)
			if (id) {
				classId = id;
				// Create a class element for this class
				$class = $('<div class="Class"><div class="ClassTable"></div></div>');
				$classTable = $class.find('.ClassTable');
				$class[0].id = 'class-' + classId;
				$class.prepend($newStar.clone());
				$class = $class.insertBefore($classLine);
				// Update class maps
				if (maps.classes[classId] === undefined) {
					maps.classes[classId] = [];
				}
				maps.classes[classId].push($course[0]);
			}

			if ($class) {
				// Group class notes into class container
				$classNotes = $classLine.nextUntil('.ClassLine', '.ClassNotes');
				$classNotes.appendTo($class);
				// Group matching class rows into table
				$classLine.appendTo($classTable);
			}

			// Retrieve instructor name
			$instructor = $classLine.find('.Instructor');
			if ($instructor.length !== 0) {

				instructorName = trimWhitespace($instructor.html());

				// If instructor is not empty and is a known person
				if (instructorName !== '' && instructorName !== 'STAFF') {

					// If class if a fast-track class
					if (instructorName.match(params.exp.fastTrack)) {
						// In which case, the instructor field will instead be a date

						$classTable.addClass('FastTrack');

					} else {

						// Update instructor maps
						instructorName = instructorName.toLowerCase();
						// If entry for instructor does not exist
						if (maps.instructors[instructorName] === undefined) {
							// Create instructor entry
							maps.instructors[instructorName] = {};
						}
						// If course entry for instructor does not exist
						if (maps.instructors[instructorName][courseId] === undefined) {
							// Create course entry
							maps.instructors[instructorName][courseId] = {};
						}
						// If class entry for instructor does not exist
						if (maps.instructors[instructorName][courseId][classId] === undefined && $class) {
							// Create class entry
							maps.instructors[instructorName][courseId][classId] = $class[0];
						}

						// Link instructors last name to RateMyProfessor
						$instructor.html(
							instructorName
							.toUpperCase()
							.replace(/^([\w\- ]+) (\w)$/gi, linkToRMP)
						);

					}

				}

			}

			// Add additional classes from ClassLine to ClassTable
			classLineClasses = $classLine.prop('class');
			classLineClasses = classLineClasses.replace(/\bclassLine\b/gi, '');
			if ($classTable) {
				$classTable.addClass(trimWhitespace(classLineClasses));
			}

			// Check for multiple (separate) entries in the same class
			$classes = $(maps.courses[courseId]).find('#class-' + classId);
			if ($classes.length > 1) {
				// Combine class entries into one entry
				$firstClass = $classes.eq(0);
				// Retrieve all entries other than the first entry
				$otherClasses = $classes.slice(1);

				// Inherit status if any entry is a fast-track class
				for (o = 0; o < $otherClasses.length; o += 1) {
					$otherClass = $otherClasses.eq(o);

					// Inherit status if any entry is a fast-track class
					if ($otherClass.hasClass('FastTrack')) {
						$firstClass.addClass('FastTrack');
						$otherClass
						.find('.ClassLine')
						.children()
						.not('.Instructor')
						.empty();
					}

				}

				// Do not repeat class number unnecessarily
				$otherClassLines = $otherClasses.find('.ClassLine');
				$otherClassLines
				.find('.ClassNumber')
				.empty();

				// Group entries
				$firstClassTable = $firstClass.find('.ClassTable');
				$otherClassLines.appendTo($firstClassTable);
				// Remove extra class entries after consolidating them
				$otherClasses.remove();

				// Truncate the list to the now first (and only) entry
				maps.classes[classId].length = 1;
			}
		}

		// If there are multiple entries in the same course
		if (maps.courses[courseId].length > 1) {
			// Combine course entries into one entry
			$courses = $(maps.courses[courseId]);
			$firstCourse = $courses.eq(0);
			$otherClasses = $courses
			// Retrieve all entries other than the first entry
			.slice(1)
			.children()
			// Exclude course headings
			.not('.CourseLine')
			// Exclude course notes
			.not('.CourseNotes');

			// Append other course enties to first entry
			$otherClasses.appendTo($firstCourse);
			// Remove extra (unnecessary) course headings
			$course.find('.CourseLine').remove();

			// Truncate the list to the now first (and only) entry
			maps.courses[courseId].length = 1;
		}

	}

	// Update current iteration (including skipped items)
	params.iteration += 1;

	// Show user the current # of loaded classes
	if (params.iteration % params.displayedIterationStep === 0) {
		// Only show every 10 classes loaded for efficiency
		updateCourseCount();
	}

	if (params.iteration === params.courseCount) {
		// Run the following code when all courses have loaded

		finish();

	} else {
		// Otherwise, parse the next course

		if (params.iteration % params.iterationStep === 0) {
			// Parse asynchronously after every 10 courses
			setTimeout(parseNextCourse, params.iterationDelay);
		} else {
			parseNextCourse();
		}

	}

}

// Parse a schedule from the given XML string
function parseSchedule(xmlStr) {
	var schedule;

	// Remove discipline headings and tabs
	xmlStr = xmlStr.replace(/<(|Tab|DisciplineHeading|DisciplineNotes)>([^<]*)<\/\1>/gi, '')
	// Convert class note types to regular class notes
	.replace(/<(N?ClassNotes)(\w+)>([^<]*)<\/\1\2>/gi, '<$1>$3</$1>')
	// Add "night" CSS class to all night classes
	.replace(/<N([a-z]+)>/gi, '<div class="$1 Night">')
	// Convert tag names to divs with CSS classes
	.replace(/<([a-z]+)>/gi, '<div class="$1">')
	// Separate campus names from ClassLine keyword
	.replace(/<div class="ClassLine(\w+)/gi, '<div class="ClassLine $1')
	// All elements are <div> elements initially
	.replace(/<\/([a-z]+)>/gi, '</div>')
	// Remove XML stylesheet
	.replace(/<\?xml([^>]+)>/gi, '')
	// Remove tildes from course names
	.replace(/~/gi, '')
	// Strip out whitespace
	.replace(/(\s*)(\n)(\s*)/gi, '')
	.replace(/\s+/gi, ' ')
	// Convert text links to clickable links
	.replace(params.exp.url, '<a href="$1" target="_blank" rel="noopener">$1</a>');

	// Parse HTML string into a DOM
	schedule = $.parseHTML(xmlStr)[0];

	if (schedule) {

		// Set schedule current schedule
		$currentSchedule = $(schedule);

		// Calculate and update course count
		$$.courseLines = $currentSchedule.find('.CourseLine');
		params.courseCount = $$.courseLines.length;
		updateCourseCount();

		// Start performance timer
		params.startTime = new Date();

		// Parse all courses, starting with the first
		parseCourse($$.courseLines.eq(0));

	}

}

// Load schedule for the given semester
function loadSchedule(semesterId) {

	// Load schedule XML string via AJAX
	$.ajax({
		url: params.basePath + '/resources/schedules/' + semesterId + '.xml',
		// Load data as a string
		dataType: 'text',
		success: function(data) {
			// Parse the given XML string into an HTML hierarchy
			parseSchedule(data);
		},
		// If the schedule with the given name does not exist
		error: function() {
			var $message;
			// Inform the user by displaying an error message
			$message = $('<p class="message visible">The schedule for the ' + params.semesterName + ' semester does not exist.</p>');
			$$.content.empty();
			$message.appendTo($$.content);
			// Indicate that search is unavailable
			$$.searchField.prop({
				placeholder: 'Search is unavailable'
			});
		}
	});

}

// Sanitize query string
function sanitizeQuery(query) {
	query = query.toLowerCase();
	query = query.replace(params.exp.queryFilter, '');
	query = query.replace(/^n /gi, 'n');
	query = trimWhitespace(query);
	return query;
}

// Update search information
function updateSearchInfo() {
	// Build message string
	var message = '',
		classCount;

	// Add number of search results to message
	message += $searchResults.length + ' course';

	// Handle plural nouns
	if ($searchResults.length !== 1) {
		message += 's';
	}

	// Add comma to delimit each statistic
	message += ', ';

	// Determine class count
	classCount = $searchResults.find('.Class').length;

	// Add class count to search info
	message += classCount + ' class';

	// Handle plural nouns
	if (classCount.length !== 1) {
		message += 'es';
	}

	// Update info message
	$$.searchInfo.html(message);
}

// Search class schedule using the given query
function search(query) {
	var suggestions, suggestion, s,
		$courses, $course, courseIds, courseId,
		$class, classIds, classId,
		$section, section, sectionId,
		instructorName,
		results, r;

	// Format and sanitize query
	query = sanitizeQuery(query);

	// Retrieve suggestions for this query
	suggestions = currentSuggestions;
	// Initialize list of search results
	results = [];

	// Use the given suggestion list to retrieve search results
	for (s = 0; s < suggestions.length; s += 1) {
		// Retrieve the suggestion for each iteration
		suggestion = suggestions[s];

		// Cap number of search results
		if (results.length === params.maxResults) {
			break;
		}

		if (suggestion.match(params.exp.classId)) {
			// Match the given class ID

			classId = parseFloat(suggestion.slice(1));
			if (maps.classes[classId] !== undefined) {

				// Clone course to allow for manipulation of its classes
				$course = $(maps.classes[classId]).clone();

				// Remove all classes except the matched class
				removeClassesNotMatching($course, '#class-' + classId);

				// Add course to search results
				results.push($course[0]);

			}

		} else if (suggestion.match(params.exp.courseName)) {
			// Match the given course name

			courseId = courseNameToCourseId(suggestion);
			if (maps.courses[courseId] !== undefined) {
				// Add course to search results
				$course = $(maps.courses[courseId]).clone();
				results.push($course[0]);
			}

		} else if (suggestion.match(params.exp.instructorName)) {
			// Match the given instructor name

			// Format instructor name
			instructorName = removeInstructorTitle(suggestion);
			instructorName = lastBeforeFirst(instructorName);

			// If instructor exists in maps
			if (maps.instructors[instructorName] !== undefined) {

				// Retrieve map of course IDs for this instructor
				courseIds = maps.instructors[instructorName];

				// Loop through course IDs
				for (courseId in courseIds) {
					if (courseIds.hasOwnProperty(courseId)) {

						// Find matching course
						$course = $(maps.courses[courseId]).clone();

						// Retrieve stored list of class IDs
						classIds = courseIds[courseId];

						// Loop through class IDs
						for (classId in classIds) {
							if (classIds.hasOwnProperty(classId)) {

								// Label matching classes
								$class = $course.find('#class-' + classId);
								$class.addClass('matching');

							}
						}

						// Remove all classes not taught by instructor
						removeClassesNotMatching($course, '.matching');

						// Add course to search results
						results.push($course[0]);

					}
				}

			}

		} else if (suggestion.match(params.exp.sectionName)) {
			// Match the given section name

			sectionId = sectionNameToId(suggestion);
			if (maps.sections[sectionId] !== undefined) {
				// Ensure # of courses in section does not exceed cap
				section = maps.sections[sectionId]
				.slice(0, params.maxResults - results.length);
				$section = $(section).clone();
				results = results.concat($section.toArray());
			}

		}
		if (maps.courseTitles[suggestion] !== undefined) {
			// Match the given course title

			$courses = $(maps.courseTitles[suggestion]).clone();
			results = results.concat($courses.toArray());

		}

	}

	// Loop through course results
	for (r = 0; r < results.length; r += 1) {
		$course = $(results[r]);
		// If course contains no classes
		if ($course.find('.Class').length === 0) {
			// Remove course element from results
			results.splice(r, 1);
			r -= 1;
		}
	}

	// Hide the currently matching courses
	hideStarredClasses();
	$$.schedule.empty();
	hide($$.searchHint);
	hide($$.loading);

	if (results.length === 0) {
		// If no results are found

		if ($currentSchedule === null) {
			// Inform user that the search could not be performed
			$$.noResults.html('Please select a semester schedule before searching.');
		} else if (query === '') {
			// Inform user that there are no search results
			$$.noResults.html('No search results to display.');
		} else {
			// Inform user that there are no search results
			$$.noResults.html('No search results to display for "' + query + '".');
		}
		show($$.noResults);
		hide($$.searchInfo);
		$searchResults = $();

	} else {

		$searchResults = $(results);

		// If there are search results, display them
		hide($$.noResults);
		show($$.searchInfo);

		// Add search results to schedule
		$$.schedule.append($searchResults);

	}
	updateSearchInfo();

}

// Get suggestions using the keys of one map and the values of another
function getSuggestionsUsingMaps(query, keyMap, valueMap, mode) {
	var suggestions, suggestion,
		index, queryMatches;

	// Create a list for storing each suggestion
	suggestions = [];

	// Iterate over key map
	for (suggestion in keyMap) {
		if (keyMap.hasOwnProperty(suggestion)) {

			// Plug each key into optional second map to get value
			if (valueMap !== null) {
				suggestion = valueMap[suggestion];
			}

			// If value is defined in the app
			if (suggestion !== undefined) {
				// Check for query within potential suggestion
				index = suggestion.indexOf(query);

				if (mode === '^') {
					// Match-beginning mode
					queryMatches = (index === 0);
				} else if (mode === '*') {
					// Match-anywhere mode
					queryMatches = (index !== -1);
				}

				// If suggestion matches query by the designated mode
				if (queryMatches) {
					// If number of suggestions exceeds cap
					if (suggestions.length === params.maxSuggestions) {
						// Stop iterating over key map
						break;
					} else {
						// Add suggestion to suggestion list
						suggestions.push(suggestion);
					}
				}

			}

		}
	}
	return suggestions;
}

// Retrieve a list of search suggestions for the given query
function getSuggestions(query) {
	var suggestions,
		section, sectionName, sectionId,
		courseId,
		courseNum, partialCourseNum,
		classId, partialClassId,
		instructorName;

	// Define a list of suggestions for this query
	suggestions = [];

	// Simplify query string for best results
	query = sanitizeQuery(query);

	// Ignore empty query strings
	if (query === '') {

		return [];

	}

	if (query.match(params.exp.instructorName)) {

		// Remove "Professor" title from query
		query = removeInstructorTitle(query);
		query = lastBeforeFirst(query);

		// Find instructor whose names matches the given query
		for (instructorName in maps.instructors) {
			if (maps.instructors.hasOwnProperty(instructorName)) {

				if (suggestions.length === params.maxSuggestions) {
					break;
				} else if (instructorName.indexOf(query) === 0) {
					// Add instructor's name as suggestion
					suggestions.push('prof. ' + firstBeforeLast(instructorName));
				}

			}
		}

		return suggestions;

	}

	// If query is an alias to a proper sectio name
	if (maps.sectionIdAliases[query] !== undefined) {
		// Refer to the proper section name
		query = maps.sectionIdAliases[query];
	}

	if (query.match(params.exp.classId)) {
		// Match courses whose classes have IDs that match the given number

		// Retrieve the given partial class ID
		partialClassId = query.replace(/#/gi, '');

		// Loop through all available class IDs
		for (classId in maps.classes) {
			if (maps.classes.hasOwnProperty(classId)) {

				if (classId.indexOf(partialClassId) === 0) {
					// If number of suggestions exceeds cap
					if (suggestions.length === params.maxSuggestions) {
							// Stop iterating over sections object
							break;
					} else {
						// Add class ID to suggestion list
						suggestions.push('#' + classId);
					}
				}

			}
		}

	} else if (query.match(params.exp.courseName) && (courseId = courseNameToCourseId(query)) && (sectionId = courseIdToSectionId(courseId)) && maps.courseNums[sectionId] !== undefined) {
		// Match courses in the given section whose course numbers start with the given number

		// Derive section name from the given section ID
		sectionName = maps.sectionNames[sectionId];
		// Retrieve the partial course number
		partialCourseNum = courseIdToCourseNum(courseId);

		// Add courses in this section as suggestions
		section = maps.courseNums[sectionId];

		// Loop through courses in section
		for (courseNum in section) {
			if (section.hasOwnProperty(courseNum)) {

				// If number of suggestions exceeds cap
				if (suggestions.length === params.maxSuggestions) {
					// Stop iterating over sections object
					break;
				}
				// If this course number begins with the given number
				if (courseNum.indexOf(partialCourseNum) === 0) {
					// Add course to list of suggestions
					suggestions.push(sectionName + ' ' + courseNum);
				}

			}
		}

	}

	// Match section names that beginn with the given query
	suggestions = suggestions.concat(
		getSuggestionsUsingMaps(query, maps.sections, maps.sectionNames, '^')
	);

	// If no matches were found
	if (suggestions.length === 0) {
		// Match section names that contain the given query

		suggestions = suggestions.concat(
			getSuggestionsUsingMaps(query, maps.sections, maps.sectionNames, '*')
		);

	}

	if (query.match(params.exp.sectionName)) {
		// Match courses with the given section name

		if (maps.sectionIds[query] !== undefined) {
			// Derive section ID from the given section name
			sectionName = query;
			sectionId = maps.sectionIds[sectionName];
		} else if (maps.sectionNames[query] !== undefined) {
			// Or, derive section name from the given section ID
			sectionId = query;
			sectionName = maps.sectionNames[sectionId];
		}

		// If section exists
		if (maps.courseNums[sectionId] !== undefined) {
			// Add courses in this section as suggestions

			if (query === sectionName) {
				// Remove redundant section name from list
				suggestions.splice(0, 1);
			}

			// Get courses in section by course number
			section = maps.courseNums[sectionId];

			// Loop through courses in section
			for (courseNum in section) {
				if (section.hasOwnProperty(courseNum)) {

					// If number of suggestions exceeds cap
					if (suggestions.length === params.maxSuggestions) {
						// Stop iterating over sections object
						break;
					}
					// Add course to list of suggestions
					suggestions.push(sectionName + ' ' + courseNum);

				}
			}

		}

	}

	if (suggestions.length === 0) {
		// Match courses with the given course title

		// Find course titles that begin with the given query
		suggestions = suggestions.concat(
			getSuggestionsUsingMaps(query, maps.courseTitles, null, '^')
		);

		if (suggestions.length === 0) {

				// Find course titles that contain the given query
				suggestions = suggestions.concat(
					getSuggestionsUsingMaps(query, maps.courseTitles, null, '*')
				);

		}

	}

	// Sort suggestions
	suggestions.sort(sortCourseNames);

	return suggestions;
}

// Update the suggestions element with the list of suggestions
function updateSuggestions(query) {
	var suggestionElements,
		suggestions, s;

	// Retrieve search suggestions for this query
	currentSuggestions = suggestions = getSuggestions(query);

	// If the suggestion list is empty or matches the query
	if (suggestions.length === 0 || (suggestions.length === 1 && suggestions[0] === query)) {

		// Hide the search popup
		hide($$.searchPopup);

	} else {
		suggestionElements = [];

		// Otherwise, reconstruct the suggestion list
		$$.suggestionList.empty();

		// Construct the suggestion list outside of the DOM
		for (s = 0; s < suggestions.length; s += 1) {
			// Append each suggestion to the list
			suggestionElements.push('<li>' + suggestions[s] + '</li>');
		}

		// Insert suggestion list into the DOM after iteration
		$$.suggestionList.append(suggestionElements);

		// Make the search popup visible again
		show($$.searchPopup);

		// Cache the suggestion list for later use
		$currentSuggestions = $$.suggestionList.find('li');

	}
	// Deselect the current search suggestion
	params.suggestionIndex = -1;
}

// Queue a search for the given query using a timer
function queueSearch(query) {
	clearTimeout(params.searchTimer);
	params.searchTimer = setTimeout(function() {
		search(query);
	}, params.searchDelay);
}

// CLear the search field
function clearSearch() {
	params.lastQuery = '';
	$$.searchField.val('');
	updateSuggestions('');
	queueSearch('');
}

// Keydown bindings for search box
$$.searchField.on('keydown', function(event) {
	var $suggestions, $suggestion;

	params.lastQuery = $$.searchField[0].value;

	if (event.which === 40 || event.which === 38) {

		$suggestions = $currentSuggestions;

		if (event.which === 40) {
			// Select next suggestion using DOWN key

			if (params.suggestionIndex >= ($suggestions.length - 1)) {
				// Index wraps around if too large
				params.suggestionIndex = -1;
			} else {
				// Otherwise, increment index
				params.suggestionIndex += 1;
			}
			// Prevent default keyboard behavior
			event.preventDefault();

		} else if (event.which === 38) {
			// Select previous suggestion using UP key

			if (params.suggestionIndex <= -1) {
				// Index wraps around if too small
				params.suggestionIndex = $suggestions.length - 1;
			} else {
				// Otherwise, decrement index
				params.suggestionIndex -= 1;
			}
			// Prevent default keyboard behavior
			event.preventDefault();

		}
		// Apply selection to suggestion elements
		$suggestions.removeClass('selected');
		if (params.suggestionIndex !== -1) {
			// Select the proper suggestion
			$suggestion = $suggestions.eq(params.suggestionIndex);
			$suggestion.addClass('selected');
		}

	}
});

// Keyup bindings for search box
$$.searchField.on('keyup', function(event) {
	var query;

	// Retrieve search query
	query = $$.searchField[0].value;

	// Press ESCAPE to clear search field
	if (event.which === 27) {
		clearSearch();
		return;
	}

	// Press ENTER to search the selected suggestion
	if (event.which === 13) {
		// If a suggestion is selected
		if (params.suggestionIndex !== -1) {
			// Retrieve the selected suggestion
			query = currentSuggestions[params.suggestionIndex];
			if (query !== undefined) {
				// Search the selected suggestion
				$$.searchField[0].value = query + ' ';
			}
		}
	}

	// If the query has changed
	if (query !== undefined && (query !== params.lastQuery)) {

		// Reconstruct displayed list of search suggestions
		updateSuggestions(query);

		if (event.which === 13) {
			// Search the selected suggestion if chosen
			search(query);
		} else {
			// Search after a short period of keyboard inactivity
			queueSearch(query);
		}

	}
});

// Invert a JSON object (swap keys with values)
function invertObject(object) {
	var inverted = {},
		propName, propValue;

	for (propName in object) {
		if (object.hasOwnProperty(propName)) {
			propValue = object[propName];
			inverted[propValue] = propName;
		}
	}
	return inverted;
}

// Click magnifying glass icon to search
$$.searchGoIcon.on('mousedown', function(event) {
	var query = $$.searchField.val();
	if (query !== '') {
		search(query);
	}
	$$.searchField.trigger('focus');
	event.preventDefault();
});
// Click X icon to clear search field
$$.searchClearIcon.on('mousedown', function(event) {
	clearSearch();
	$$.searchField.trigger('focus');
	event.preventDefault();
});

// Click a search suggestion to search it
$$.suggestionList.on('mousedown', 'li', function(event) {
	var query = $(this).html();
	$$.searchField.val(query + ' ');
	updateSuggestions(query);
	search(query);
	$$.searchField.trigger('focus');
	event.preventDefault();
});
// Add touchstart event to allow for "selected" class to take effect
$$.suggestionList.on('touchstart', 'li', function() {});

// Select a suggestion by hovering over it
$$.suggestionList.on('mouseover', 'li', function(event) {
	var $suggestions, $suggestion;
	$suggestions = $currentSuggestions;
	$suggestion = $(this);
	// Update styling
	$suggestions.removeClass('selected');
	$suggestion.addClass('selected');
	// Update internal index
	params.suggestionIndex = $suggestion.index();
	event.preventDefault();
});

// Click the star next to a class listing to toggle its state
$$.schedule.on('mousedown', '.star', function(event) {
	toggleClassStar($(this).parent('.Class'));
	event.preventDefault();
});

// Click the main star control to toggle the display of starred classes
$$.toggleStarredContainer.on('mousedown', function(event) {
	if (params.finishedLoading) {
		toggleStarredClasses();
	}
	event.preventDefault();
});

// Show loading message
show($$.loading);

// The search field should be empty initially
$$.searchField.val('');

// Disable search field temporarily
$$.searchField.prop({
	disabled: true,
	placeholder: 'Loading\u2026'
});
$$.searchGoIcon.addClass('loading');
$$.toggleStarredContainer.addClass('loading');

// Load section ID maps via AJAX
$.ajax({
	url: params.basePath + '/resources/maps/section-names.json',
	// Load data as a string
	dataType: 'text',
	success: function(data) {
		// Run the below code when loading completes

		// Parse the JSON string into an object
		maps.sectionNames = JSON.parse(data);
		// Map section IDs to names using existing map
		maps.sectionIds = invertObject(maps.sectionNames);

		// Retrieve semester ID and determine semester name
		params.semesterId = $$.semesterId.html();
		params.semesterId = trimWhitespace(params.semesterId);
		params.semesterId = params.semesterId.toLowerCase();
		params.semesterName = semesterIdToName(params.semesterId);
		// Name of localStorage entry for storing starred classes
		params.starredEntryName = 'starred-' + params.semesterId;

		// Update semester name on page
		$$.semesterName.html(params.semesterName);
		document.title = params.semesterName + ' Class Schedule | Palomar Scheduler';

		// Load the schedule for the defined semester
		loadSchedule(params.semesterId);

	}

});

});
}(jQuery, window, document, parseFloat, Date, setTimeout, clearTimeout, localStorage, JSON));
